<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <h5 class="modal-title">{{ title }}</h5>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <span *ngIf="cost.value?.total" class="total-amount float-left">
          <span class="total-amount-title">Total: </span>
          <span>{{ cost.value?.total | tokeetCurrency: rental?.currency }}</span>
        </span>
        <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
          <span class="fal fa-times"></span>
          Cancel
        </button>
        <button *ngIf="cost.value" (click)="save(form)" type="button" class="btn btn-success text-uppercase">
          <span class="fal fa-save"></span>
          Save
        </button>
        <button
          *ngIf="!cost.value"
          (click)="save(form)"
          matTooltip="Please fill out all required fields"
          matTooltipClass="text-center"
          matTooltipPosition="below"
          type="button"
          class="btn btn-success text-uppercase"
        >
          <span class="fal fa-save"></span>
          Save
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fal fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div *ngIf="data?.isClone" class="row">
        <div class="col-md-12">
          <alert type="warning">
            <strong>Warning:</strong> This booking is a clone. Please modify the details, before clicking
            <strong>Save</strong> to create the booking.
          </alert>
        </div>
      </div>
      <form [formGroup]="form" class="clearfix">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <h6 class="section-title">Guest Details</h6>
              </div>
              <div class="col-md-12 d-flex align-items-center">
                <app-select-search
                  bindLabel="name"
                  floatLabel="never"
                  (search)="guestSearch.next($event)"
                  [multiple]="false"
                  [items]="guests$ | async"
                  [ctrl]="form.get('guest')"
                  placeholder="Search for Guest (optional)"
                ></app-select-search>
                <ng-container *ngIf="form.get('guest').value">
                  <button class="btn btn-danger text-nowrap ml-3" (click)="onClearSelectedGuest()">
                    <i class="fal fa-undo"></i> Clear Guest
                  </button>
                </ng-container>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input type="text" formControlName="guestName" matInput required placeholder="Guest Name" />
                  <mat-error *ngIf="form.get('guestName').touched && form.get('guestName').hasError('required')">
                    Name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('guestName').touched && form.get('guestName').hasError('minlength')">
                    Name must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('guestName').touched && form.get('guestName').hasError('maxlength')">
                    Name must be at most <strong>50</strong> characters long
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input type="text" formControlName="guestEmail" matInput required placeholder="Guest Email" />
                  <mat-error *ngIf="form.get('guestEmail').touched && form.get('guestEmail').hasError('required')">
                    Email is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('guestEmail').touched && form.get('guestEmail').hasError('email')">
                    Email must have valid format
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input type="text" formControlName="guestPhone" matInput placeholder="Guest Phone" />
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field [floatLabel]="'never'" class="mat-block">
                  <mat-select
                    formControlName="source"
                    placeholder="Source:"
                    [required]="true"
                    (selectionChange)="engineCost.next('')"
                  >
                    <mat-option *ngFor="let channel of channels$ | async" [value]="channel.id">{{
                      channel.label
                    }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('source').touched && form.get('source').hasError('required')">
                    Channel is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field class="mat-block">
                      <input
                        type="number"
                        min="1"
                        step="1"
                        (change)="engineCost.next('')"
                        formControlName="adults"
                        matInput
                        required
                        placeholder="Adults"
                      />
                      <mat-error *ngIf="form.get('adults').touched && form.get('adults').hasError('required')">
                        Adults field is <strong>required</strong>
                      </mat-error>
                      <mat-error *ngIf="form.get('adults').touched && form.get('adults').hasError('pattern')">
                        Adults field must be a <strong>whole number</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="mat-block">
                      <input
                        type="number"
                        min="0"
                        step="1"
                        (change)="engineCost.next('')"
                        formControlName="children"
                        matInput
                        placeholder="Children"
                      />
                      <mat-error *ngIf="form.get('children').touched && form.get('children').hasError('pattern')">
                        Children field must be a <strong>whole number</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div *ngIf="overMaxGuests$ | async" class="col-md-12 cost-error">
                <mat-error>Maximum guests is {{ cost.value?.maxguests }}</mat-error>
              </div>
              <div *ngIf="underMinGuests$ | async" class="col-md-12 cost-error">
                <mat-error>Minimum guests is {{ cost.value?.sleep_min }}</mat-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <h6 class="section-title">Charges Details</h6>
              </div>
              <div class="col-md-12">
                <app-select-search
                  bindValue="id"
                  bindLabel="name"
                  floatLabel="never"
                  [multiple]="false"
                  [items]="rentals$ | async"
                  [ctrl]="form.get('rentalId')"
                  placeholder="Rental"
                >
                  <mat-error
                    class="error-container"
                    *ngIf="form.get('rentalId').touched && form.get('rentalId').hasError('required')"
                  >
                    Rental is <strong>required</strong>
                  </mat-error>
                </app-select-search>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field class="mat-block">
                      <input
                        matInput
                        [matDatepicker]="arriveDate"
                        placeholder="Arrive:"
                        [min]="minDateDefault"
                        [max]="maxArriveDate.value || maxDateDefault"
                        [required]="true"
                        (focus)="arriveDate.open()"
                        (dateChange)="engineCost.next('')"
                        (dateInput)="engineCost.next('')"
                        formControlName="arriveDate"
                        readonly
                      />
                      <mat-datepicker-toggle matSuffix [for]="arriveDate"></mat-datepicker-toggle>
                      <mat-datepicker #arriveDate></mat-datepicker>
                      <mat-error *ngIf="form.get('arriveDate').touched && form.get('arriveDate').hasError('required')">
                        Value is <strong>required</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="mat-block">
                      <input
                        matInput
                        [matDatepicker]="departDate"
                        placeholder="Depart:"
                        [required]="true"
                        [min]="minDepartDate.value || minDateDefault"
                        [max]="maxDateDefault"
                        (dateChange)="engineCost.next('')"
                        (dateInput)="engineCost.next('')"
                        (focus)="departDate.open()"
                        formControlName="departDate"
                        readonly
                      />
                      <mat-datepicker-toggle matSuffix [for]="departDate"></mat-datepicker-toggle>
                      <mat-datepicker #departDate></mat-datepicker>
                      <mat-error *ngIf="form.get('departDate').touched && form.get('departDate').hasError('required')">
                        Value is <strong>required</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12 cost-error">
                <mat-error *ngIf="(isCheckinBlocked$ | async) as weekday"> Checkin is blocked on {{weekday}} </mat-error>
                <mat-error *ngIf="(isCheckoutBlocked$ | async) as weekday"> Checkout is blocked on {{weekday}} </mat-error>
                <mat-error *ngIf="underMinStay$ | async as minStay">Minimum stay is {{ minStay }}</mat-error>
                <mat-error *ngIf="overMaxStay$ | async as maxStay">Maximum stay is {{ maxStay }}</mat-error>
                <mat-error *ngIf="minAdvanceDays$ | async as minAdvanceDays">
                  Minimum Advance Booking is {{ minAdvanceDays }} {{minAdvanceDays > 1 ? 'days' :'day'}}
                </mat-error>
                <mat-error *ngIf="maxAdvanceDays$ | async as maxAdvanceDays">
                  Maximum Advance Booking is {{ maxAdvanceDays }} days
                </mat-error>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input
                    type="number"
                    min="0"
                    formControlName="charge"
                    (keyup)="onChargeChange($event.target.value)"
                    matInput
                    placeholder="Base Charge:"
                    [required]="true"
                  />
                  <mat-error *ngIf="form.get('charge').touched && form.get('charge').hasError('required')">
                    Base Charge is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="!!cost.value?.extraGuests" class="col-md-12">
                <div class="row extra-guests-row">
                  <div class="col-md-2 extra-guests-padding"></div>
                  <div class="col-md-10 extra-guests">Additional Guests Fee: {{ cost.value?.extraGuests }}</div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row" *ngFor="let item of cost?.value?.auditDiscounts">
                  <div class="col-md-2 d-flex align-items-center justify-content-center">
                    <i class="fal fa-eye clickable" (click)="onViewDiscount(item)"></i>
                  </div>
                  <div class="col-md-10 pl-0">
                    <mat-form-field class="mat-block">
                      <input
                        type="number"
                        [value]="item.disc_amount"
                        matInput
                        disabled
                        [placeholder]="item.disc_type === 'lengthofstay' ? 'LOS Discount' : 'Discount Code'"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div formArrayName="discounts" *ngFor="let item of discounts.controls; let i = index" class="row">
                  <div class="col-md-2 discount-controls">
                    <button
                      *ngIf="discounts.length === i + 1 && discounts.length < discountsOrFeesLimit"
                      (click)="addDiscountsOrFees()"
                      class="add-discount discount-btn"
                      type="button"
                    >
                      <i class="fal fa-plus"></i>
                    </button>
                    <button
                      *ngIf="discounts.length !== i + 1"
                      (click)="removeDiscountsOrFees(i)"
                      class="remove-discount discount-btn"
                      type="button"
                    >
                      <i class="fal fa-minus"></i>
                    </button>
                  </div>
                  <div [formGroupName]="i" class="col-md-10 discount-holder">
                    <mat-form-field class="mat-block">
                      <input
                        type="number"
                        (change)="engineCost.next('')"
                        formControlName="amount"
                        matInput
                        placeholder="Discounts & Fees:"
                      />
                      <mat-error *ngIf="item.get('amount').hasError('zero')"> Value shouldn't be zero. </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div [class.hidden]="fees.controls.length === 0" class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h6 class="taxes-heading">Booking Fees</h6>
                  </div>
                </div>
                <div
                  formArrayName="fees"
                  *ngFor="let item of fees.controls; let i = index"
                  class="d-flex align-items-center"
                >
                  <ng-container [formGroupName]="i">
                    <mat-checkbox
                      formControlName="selected"
                      #feeSelected
                      (change)="updateBookingFees()"
                      [matTooltip]="feeSelected.checked ? 'Uncheck to ignore this fee' : 'Check to apply this fee'"
                      class="mr-3"
                    ></mat-checkbox>
                    <div class="row flex-fill">
                      <div class="col-md-3">
                        <mat-form-field
                          [matTooltip]="item.get('name')?.value"
                          matTooltipClass="text-center"
                          matTooltipPosition="above"
                          class="mat-block"
                        >
                          <input type="text" formControlName="name" matInput placeholder="Fee Name:" />
                        </mat-form-field>
                      </div>
                      <div class="col-md-3 pl-0">
                        <mat-form-field class="mat-block">
                          <mat-label
                            ><span
                              [innerHtml]="
                                'Fee Rate (' +
                                (item.get('type')?.value === 'flat' ? rental?.currency?.symbol : '%') +
                                '):'
                              "
                            ></span
                          ></mat-label>
                          <input type="number" min="0" formControlName="rate" matInput />
                        </mat-form-field>
                      </div>
                      <div
                        class="col-md-3 pl-0"
                        [matTooltip]="feeModalityLabels[item.get('modality')?.value]"
                        matTooltipPosition="above"
                      >
                        <mat-form-field class="mat-block">
                          <mat-select formControlName="modality" placeholder="Modality">
                            <mat-option [value]="feeModalities.PerStay">{{
                              feeModalityLabels[feeModalities.PerStay]
                            }}</mat-option>
                            <mat-option [value]="feeModalities.PerNight">{{
                              feeModalityLabels[feeModalities.PerNight]
                            }}</mat-option>
                            <mat-option [value]="feeModalities.PerPerson">{{
                              feeModalityLabels[feeModalities.PerPerson]
                            }}</mat-option>
                            <mat-option [value]="feeModalities.PerPersonPerNight">{{
                              feeModalityLabels[feeModalities.PerPersonPerNight]
                            }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-md-3 pl-0">
                        <mat-form-field class="mat-block">
                          <span
                            matPrefix
                            [innerHtml]="rental?.currency?.symbol"
                            *ngIf="!(item.get('amount').value | isNil)"
                          ></span>
                          <input type="number" min="0" formControlName="amount" matInput placeholder="Fee Amount:" />
                        </mat-form-field>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div [class.hidden]="potentialFees.controls.length === 0" class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h6 class="taxes-heading">These booking fees may apply</h6>
                  </div>
                </div>
                <div formArrayName="potentialFees" *ngFor="let item of potentialFees.controls; let i = index">
                  <div class="row" [formGroupName]="i">
                    <div class="col-md-3">
                      <mat-form-field
                        [matTooltip]="item.get('name')?.value"
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        class="mat-block"
                      >
                        <input type="text" formControlName="name" matInput placeholder="Fee Name:" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-3 pl-0">
                      <mat-form-field class="mat-block">
                        <mat-label
                          ><span
                            [innerHtml]="
                              'Fee Rate (' +
                              (item.get('type')?.value === 'flat' ? rental?.currency?.symbol : '%') +
                              '):'
                            "
                          ></span
                        ></mat-label>
                        <input type="number" min="0" formControlName="rate" matInput />
                      </mat-form-field>
                    </div>
                    <div
                      class="col-md-3 pl-0"
                      [matTooltip]="feeModalityLabels[item.get('modality')?.value]"
                      matTooltipPosition="above"
                    >
                      <mat-form-field class="mat-block">
                        <mat-select formControlName="modality" placeholder="Modality">
                          <mat-option [value]="feeModalities.PerStay">{{
                            feeModalityLabels[feeModalities.PerStay]
                          }}</mat-option>
                          <mat-option [value]="feeModalities.PerNight">{{
                            feeModalityLabels[feeModalities.PerNight]
                          }}</mat-option>
                          <mat-option [value]="feeModalities.PerPerson">{{
                            feeModalityLabels[feeModalities.PerPerson]
                          }}</mat-option>
                          <mat-option [value]="feeModalities.PerPersonPerNight">{{
                            feeModalityLabels[feeModalities.PerPersonPerNight]
                          }}</mat-option>
                          <mat-option [value]="feeModalities.PerDays">{{
                            feeModalityLabels[feeModalities.PerDays]
                          }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-md-3 pl-0">
                      <mat-form-field class="mat-block">
                        <span
                          matPrefix
                          [innerHtml]="rental?.currency?.symbol"
                          *ngIf="!(item.get('amount').value | isNil)"
                        ></span>
                        <input type="number" min="0" formControlName="amount" matInput placeholder="Fee Amount:" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div [class.hidden]="taxes.controls.length === 0" class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h6 class="taxes-heading">Taxes</h6>
                  </div>
                </div>
                <div formArrayName="taxes" *ngFor="let item of taxes.controls; let i = index">
                  <div class="row" [formGroupName]="i">
                    <div class="col-md-4">
                      <mat-form-field class="mat-block">
                        <input type="text" formControlName="taxName" matInput placeholder="Tax Name:" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-4">
                      <mat-form-field class="mat-block">
                        <input type="number" min="0" formControlName="taxRate" matInput placeholder="Tax Rate:" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-4">
                      <mat-form-field class="mat-block">
                        <input type="number" min="0" formControlName="taxAmount" matInput placeholder="Tax Amount:" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="cost.value" class="col-sm-12">
                <div class="total-amount float-right">
                  <span class="total-amount-title">Total: </span>
                  <span>{{ cost.value?.total | tokeetCurrency: rental?.currency }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
